import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import SignaturePad from 'signature_pad';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-sign-modal',
  templateUrl: './sign-modal.component.html',
  styleUrls: [ './sign-modal.component.scss' ]
})
export class SignModalComponent {
  @ViewChild('signDialog', { static: true }) signDialog: TemplateRef<any>;

  @Input() hideToPrint: boolean = false;
  @Input() disable: boolean = false;
  @Output() completeSign: EventEmitter<string> = new EventEmitter<string>();

  public canvas;
  public signaturePad;

  public signPNG: string;

  constructor(
    private dialog$: MatDialog
  ) {
  }

  showSignDialog(): void {
    const dialog = this.dialog$.open(this.signDialog, {
      width: '500px',
      height: '400px'
    });

    dialog.afterOpened().subscribe(value => {
      this.canvas = document.getElementById('signature-pad');
      this.signaturePad = new SignaturePad(this.canvas, {
        backgroundColor: 'rgb(255, 255, 255)' // necessary for saving image as JPEG; can be removed is only saving as PNG or SVG
      });
    });

    dialog.afterClosed().subscribe(value => {
      this.signPNG = this.signaturePad.toDataURL();
      this.completeSign.next(this.signPNG);
    });
  }

  clearSign(): void {
    this.signaturePad.clear();
  }

}
